import { User } from '../../../user-management/users/user';
import { Account } from '../../model/account';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CompanySettings } from '../../../settings/model/company-settings';

@Component({
  selector: 'ls-account-information',
  templateUrl: './account-information.component.html',
  styles: ['.capitalize { text-transform: capitalize; }'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountInformationComponent {
  @Input()
  public account: Account;
  @Input()
  public user: User;
  @Input()
  public companySettings: CompanySettings;
}
